/**
 * Workspace Metrics Page
 *
 * Admin page for viewing comprehensive workspace metrics and analytics.
 * Protected by AdminProtectedRoute requiring admin role + can_view_analytics permission.
 */

import React from 'react';
import { MetricsManagement } from '../features/metrics/components/MetricsManagement';
import { useAuth } from '../../../contexts/AuthContext';
import { LoadingSpinner } from '../../common';

export const WorkspaceMetricsPage: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a]">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  // Check if user has can_view_analytics or can_admin permission
  const hasPermission = user?.canViewAnalytics || user?.canAdmin;

  if (!hasPermission) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-[#0a0a0a] p-6">
        <div className="bg-[#2a2a2a] rounded-xl p-8 border border-[#333333] max-w-md text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Acesso Negado</h1>
          <p className="text-[#888888] mb-6">
            Você não tem permissão para visualizar as métricas do workspace.
            Entre em contato com o administrador para solicitar acesso.
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-[#F4CC04] hover:bg-[#D4B104] text-black font-medium rounded-lg transition-colors"
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  return <MetricsManagement />;
};

export default WorkspaceMetricsPage;
